import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "tv_cong_ty_lu_hanh";

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};
moduleApi.updateHdvUuDai = (dataForm) => {
    let api = {
        module: moduleName,
        type: "update_hdv_uu_dai",
        value: dataForm,
        message: {
            success: "Cập nhật thành công", //string | null | comment
            error: "Cập nhật không thành công", //string | null | comment
        },
    };
    return ApiService(api);
};
export default moduleApi;